// import * as React from 'react';
import React, { useState, useContext } from 'react';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MoreIcon from '@mui/icons-material/MoreVert';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { Link as RouterLink } from 'react-router-dom';
import UserName from '../user/UserName';
import ThemeMenuItem from './ThemeMenuItem';
import {useMsal} from '@azure/msal-react';
// import MsalLogout from './LogoutMsal';
import { InteractionStatus } from '@azure/msal-browser';
import msalLogout from 'src/pages/core/authentication/LogoutMsal';
export default function AppBarMobileMenu({ isDark, setTheme, userData }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { inProgress } = useMsal();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    const { None } = InteractionStatus;
    msalLogout(inProgress, None);
  };

  return (
    <React.Fragment>
      <IconButton
        onClick={handleClick}
        size='small'
        sx={{ ml: 2, color: isDark ? 'white' : '#000000' }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{
          color: isDark ? 'white' : '#000000',
          '& .MuiMenu-root': {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? '#424242' : '#FFFFFF'
          },
          '& .MuiPaper-root': {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? '#424242' : '#FFFFFF'
          },
          '& .MuiMenu-list': {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? '#424242' : '#FFFFFF'
          }
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            // '& .MuiAvatar-root': {
            //     width: 32,
            //     height: 32,
            //     ml: -0.5,
            //     mr: 1,
            // },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: isDark ? '#424242' : '#FFFFFF',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <UserName email={userData?.me?.email} />
        </MenuItem>
        <Divider />
        <ThemeMenuItem setTheme={setTheme} isDark={isDark} />
        <Divider />
        <MenuItem>
          <ListItemIcon>
            <Avatar
              fontSize='small'
              sx={{ color: isDark ? 'white' : '#000000' }}
            />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <Avatar
              fontSize='small'
              sx={{ color: isDark ? 'white' : '#000000' }}
            />
          </ListItemIcon>
          My account
        </MenuItem>
        <Divider />
        <MenuItem component={RouterLink} to='/app/settings'>
          <ListItemIcon>
            <Settings
              fontSize='small'
              sx={{ color: isDark ? 'white' : '#000000' }}
            />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem
          //   component={RouterLink} to="/app/logout"
          onClick={handleLogout}
        >
          <ListItemIcon>
            <Logout
              fontSize='small'
              sx={{ color: isDark ? 'white' : '#000000' }}
            />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
